module.exports = __webpack_public_path__ + "static/media/sa-cs.376e35d6.png";